$(document).ready(function () {

  // localStorage.removeItem("yeardata");
  
  if($('body').hasClass('index') || $('body').hasClass('collection') ){
    var search_yeardata = localStorage.getItem('yeardata');
    if(search_yeardata == null){
       $('.collection_filter').addClass('loading');
       $('.main_filter ').addClass('ymm_load');
    }
   

function setCookie(cname, cvalue, hours) {
  const d = new Date();
  d.setTime(d.getTime() + (1 * 60 * 60 * 1000)); // Hours to milliseconds
  console.log(d.setTime(d.getTime() + (1 * 60 * 60 * 1000)));
  let expires = "expires=" + d.toUTCString();
  console.log(expires);
  document.cookie = cname + "=" + cvalue + ";" + expires + ";path=/";
}

function getCookie(cname) {
  let name = cname + "=";
  let decodedCookie = decodeURIComponent(document.cookie);
  let ca = decodedCookie.split(';');
  for (let i = 0; i < ca.length; i++) {
    let c = ca[i].trim();
    if (c.indexOf(name) == 0) {
      return c.substring(name.length, c.length);
    }
  }
  return "";
}

function checkCookie() {
  let pop = getCookie("homepage");
  if (pop) {
   
  }else {
     localStorage.removeItem("yeardata");
  }
}
checkCookie();
    
    function allartworks() {
         $.ajax({  
            method: 'GET',
            url: 'https://dev.shopifyexperthelp.com/app/project_app/Autotech/list_product.php',
            dataType: 'HTML',
            beforeSend: function() {},
            data: {}
            }).done(function(resdata) {
           console.log(resdata);
                 $(document).find('#checkFilter').html('');
                 var respData = JSON.parse(resdata);
                 console.log(respData);
                 if(respData['status'] == 1){
                    var storesa = respData['jsonData'];
                    $(document).find('#checkFilter').html(storesa);
                    localStorage.setItem('yeardata', storesa);

                    var search_yeardata = localStorage.getItem('yeardata');
                   if (search_yeardata == null) {

                   }else{
                      $(document).find('.hiddenSelect .checkFilter').html('');
                        $(document).find('.hiddenSelect .checkFilter').html(search_yeardata);
                      setTimeout(()=>{
                        processOptions();
                      },1000)
                   }
              }
           });
    }
    if (search_yeardata == null) {
      allartworks();
    } else{
      $(document).find('.hiddenSelect .checkFilter').html('');
        $(document).find('.hiddenSelect .checkFilter').html(search_yeardata);
      setTimeout(()=>{
        processOptions();
        setCookie("homepage", "verification", 1); 
        checkCookie(); 
      },1000)
   }
    
    function processOptions() {
        var getDataSearch = $(document).find('.hiddenSelect').html();
      // console.log(getDataSearch);
        if (getDataSearch) {
          
            var yearFilterA = [];
            var makeFilterA = [];
            var modalFilterA = [];
            var confiFilterA = [];
            $(getDataSearch).find('option[data-value]').each(function () {
                var filterloop = $(this).val();
                var filterSplit = filterloop.split('_');
                var filterSplitOne = filterSplit[1];
                yearFilterA.push(filterSplitOne);
                var filterSplitTwo = filterSplit[2];
                makeFilterA.push(filterSplitTwo);
                var filterSplitThree = filterSplit[3];
                modalFilterA.push(filterSplitThree);
                var filterSplitfour = filterSplit[4];
                confiFilterA.push(filterSplitfour);
            });

            var uniqueValue = yearFilterA.filter(function(itm, i, yearFilterA) {
              return i == yearFilterA.indexOf(itm);
            });
             $.each(uniqueValue,function(index, value){
              var dataval = value.toLowerCase();
              var dataText = value.toUpperCase();
              var datavalue = dataval.replace(" ","-");
             
              $("#yearFilterSelect").append('<option class="optionList" data-value="' + datavalue + '" value="' + value + '">' + dataText + '</option>');
              var $select = $("#yearFilterSelect");
              $select.append($select.find(".optionList").remove()
                .sort(function(a, b) {
                var at = $(a).text(),
                bt = $(b).text();
                return (at < bt) ? 1 : ((at > bt) ? -1 : 0);
              }));
             });
        
            // Similar processing for other filters...
            $('.collection_filter').removeClass('loading');
            $(document).find('.Year_Filter').removeClass('disabled');
            $('.main_filter ').removeClass('ymm_load');
        }
    }

   
  }




$(document).on('change','#yearFilterSelect',function(){
  
 var vehicalVal = $(this).val();
  var inputHidden = $('#year_hidden[type="hidden"]').val(vehicalVal);
  if(inputHidden){
    $(document).find('.Mak_Filter').removeClass('disabled');
  }else{
    $(document).find('.Mak_Filter').addClass('disabled');
  }
  var makfilterArry = [];
  $('#makFilterSelect option[data-value]').remove();
  $('.checkFilter option').each(function(){
    var filterVal = $(this).val();
   
    var result = filterVal.toLowerCase().includes(vehicalVal.toLowerCase() + '_');
    if(result){
      var getfilter = $(this).text().trim();
      var splitfilter = getfilter.split('_');
      var filterOne = splitfilter[2];
      makfilterArry.push(filterOne);
    }
    
  });
  var uniqueValue = makfilterArry.filter(function(itm, i, makfilterArry) {
    return i == makfilterArry.findIndex(t => t.toLowerCase() === itm.toLowerCase());
  });
   $.each(uniqueValue,function(index, value){
       var dataval = value.toLowerCase().replace(/\s+/g, "-");
      var dataText = value.toUpperCase();
      var datavalue = dataval.replace(" ","-");
      $("#makFilterSelect").append('<option class="optionList" data-value="' + datavalue + '" value="' + value + '">' + dataText + '</option>');
      var $select = $("#makFilterSelect");
      $select.append($select.find(".optionList").remove()
        .sort(function(a, b) {
        var at = $(a).text(),
        bt = $(b).text();
        return (at > bt) ? 1 : ((at < bt) ? -1 : 0);
      }));
   });
    $('#make_hidden[type="hidden"]').val('');
    $('#makFilterSelect option[data-attr="disabled-val"]').prop('selected', true);
    $('#model_hidden[type="hidden"]').val('');
    $('.Model_Filter').addClass('disabled');
    $('#modelFilterSelect option[data-attr="disabled-val"]').prop('selected', true);
    $('#vehicle_hidden[type="hidden"]').val('');
    $('.vehicle_Filter').addClass('disabled');
    $('#vehicleFilterSelect option[data-attr="disabled-val"]').prop('selected', true);
    $('.findbutton').addClass('disabled_find');
 
});

$(document).on('change','#makFilterSelect',function(){
  var vehicalVal = $(this).val();
  var inputHidden = $('#make_hidden[type="hidden"]').val(vehicalVal);
  if(inputHidden){
    $(document).find('.Model_Filter ').removeClass('disabled');
  }else{
    $(document).find('.Model_Filter ').addClass('disabled');
  }
  var year_check = $('#year_hidden[type="hidden"]').val();
  var check_ymm = year_check+'_'+vehicalVal+'_';
  var makfilterArry = [];
  $('#modelFilterSelect option[data-value]').remove();
  $('.checkFilter option').each(function(){
    var filterVal = $(this).val();
    var result = filterVal.toLowerCase().includes(check_ymm.toLowerCase());
    if(result){
      var getfilter = $(this).text().trim();
      var splitfilter = getfilter.split('_');
      var filterOne = splitfilter[3];
      makfilterArry.push(filterOne);
    }
  });
  var uniqueValue = makfilterArry.filter(function(itm, i, makfilterArry) {
    return i == makfilterArry.findIndex(t => t.toLowerCase() === itm.toLowerCase());
  });
   $.each(uniqueValue,function(index, value){
       var dataval = value.toLowerCase().replace(/\s+/g, "-");
      var dataText = value.toUpperCase();
      var datavalue = dataval.replace(" ","-");
      $("#modelFilterSelect").append('<option class="optionList" data-value="' + datavalue + '" value="' + value + '">' + dataText + '</option>');
      var $select = $("#modelFilterSelect");
      $select.append($select.find(".optionList").remove()
        .sort(function(a, b) {
        var at = $(a).text(),
        bt = $(b).text();
        return (at > bt) ? 1 : ((at < bt) ? -1 : 0);
      }));
   });

  $('#model_hidden[type="hidden"]').val('');
  $('#modelFilterSelect option[data-attr="disabled-val"]').prop('selected', true);
  $('#vehicle_hidden[type="hidden"]').val('');
  $('.vehicle_Filter').addClass('disabled');
  $('#vehicleFilterSelect option[data-attr="disabled-val"]').prop('selected', true);
 $('.findbutton').addClass('disabled_find');
});


$(document).on('change','#modelFilterSelect',function(){
  var vehicalVal = $(this).val();
  var markValue = $('#model_hidden[type="hidden"]').val(vehicalVal);
  if(markValue){
    $('.vehicle_Filter').removeClass('disabled');
  }else{
    $('.vehicle_Filter').addClass('disabled');
  }

  var year_check = $('#year_hidden[type="hidden"]').val();
  var make_check = $('#make_hidden[type="hidden"]').val();
  var check_ymm = year_check+'_'+ make_check +'_'+vehicalVal+'_';
  var makfilterArry = [];
  $('#vehicleFilterSelect option[data-value]').remove();
  $('.checkFilter option').each(function(){
    var filterVal = $(this).val();
    var result = filterVal.toLowerCase().includes(check_ymm.toLowerCase());
   
    if(result){
      var getfilter = $(this).text().trim();
       console.log(getfilter);
      var splitfilter = getfilter.split('_');
      var filterOne = splitfilter[4];
      makfilterArry.push(filterOne);
    }
  });
  var uniqueValue = makfilterArry.filter(function(itm, i, makfilterArry) {
    return i == makfilterArry.findIndex(t => t.toLowerCase() === itm.toLowerCase());
  });
   $.each(uniqueValue,function(index, value){
      var dataval = value.toLowerCase().replace(/\s+/g, "-");
      var dataText = value.toUpperCase();
      var datavalue = dataval.replace(" ","-");
      $("#vehicleFilterSelect").append('<option class="optionList" data-value="' + datavalue + '" value="' + value + '">' + dataText + '</option>');
      var $select = $("#vehicleFilterSelect");
      $select.append($select.find(".optionList").remove()
        .sort(function(a, b) {
        var at = $(a).text(),
        bt = $(b).text();
        return (at > bt) ? 1 : ((at < bt) ? -1 : 0);
      }));
   });

  $('#vehicle_hidden[type="hidden"]').val('');
  $('#vehicleFilterSelect option[data-attr="disabled-val"]').prop('selected', true);
 $('.findbutton').addClass('disabled_find');
});

$(document).on('change','#vehicleFilterSelect',function(){
  var vehicalVal = $(this).val();
  var inputHidden = $('#vehicle_hidden[type="hidden"]').val(vehicalVal);
  if(inputHidden){
    $(document).find('.findbutton').removeClass('disabled_find');
  }else{
    $(document).find('.findbutton').addClass('disabled_find');
  }
});

$(document).on('click touch','#findMobileValue',function(){       
  var vehicle = $('input#vehicle_hidden').val(),
  make = $('input#make_hidden').val(),
  year = $('input#year_hidden').val(),
  modal = $('input#model_hidden').val();

    if (window.location.pathname === '/') {
      var find = '/search?options%5Bunavailable_products%5D=show&options%5Bprefix%5D=last&q=Filter_' + year + '_' + make + '_' + modal + '_' + vehicle + '&type=collection';
    } else {
      var find = '/search?options%5Bunavailable_products%5D=show&options%5Bprefix%5D=last&q=Filter_' + year + '_' + make + '_' + modal + '_' + vehicle + '&type=product';
    }
  // find = '/search?options%5Bunavailable_products%5D=show&options%5Bprefix%5D=last&q=Filter_'+year+'_'+make+'_'+modal+'_'+vehicle+'&type=product';
  window.location.href = find;

  $('input#vehicle_hidden').val('');
  $('input#make_hidden').val('');
  $('input#year_hidden').val('');
  $('input#model_hidden').val('');
  $(document).find('.Mak_Filter').addClass('disabled');
  $(document).find('.Model_Filter').addClass('disabled');
  $(document).find('.vehicle_Filter').addClass('disabled');
  $(document).find('.findbutton').addClass('disabled_find');
  $('#vehicleFilterSelect option[data-attr="disabled-val"]').prop('selected', true);
  $('#yearFilterSelect option[data-attr="disabled-val"]').prop('selected', true);
  $('#makFilterSelect option[data-attr="disabled-val"]').prop('selected', true);
  $('#modelFilterSelect option[data-attr="disabled-val"]').prop('selected', true);
});

if($(document).find('.template--search').length == 1){
  var searchInput = $(document).find('.search_page .message .highlight').text();
  let text = searchInput;
  let result = text.includes('Filter_');
  if(result){
    $(document).find('.search_page .message').hide();
  }
  var searchInputVal = $(document).find('.search_page .search-field[type="search"]').val();
  let textVal = searchInputVal;
  let resultVal = textVal.includes('Filter_');
  if(resultVal){
    $(document).find('.search_page .search-field[type="search"]').val('');
  }
} 
// main Product page


var main_yearVal = $(document).find('.form-validation').find('#yearFilterSelect_main_product [data-value]:selected').length;
var main_makeVal = $(document).find('.form-validation').find('#makFilterSelect_main_product [data-value]:selected').length;
var main_modelVal = $(document).find('.form-validation').find('#modelFilterSelect_main_product [data-value]:selected').length;
var main_vehicleVal = $(document).find('.form-validation').find('#vehicleFilterSelect_main_product [data-value]:selected').length;


if(main_yearVal == 0 || main_makeVal == 0 || main_modelVal == 0 || main_vehicleVal == 0 ){
  $(document).find('.main_productN').find('.itg_add_btn').addClass('disabled_input');
}else{
  $(document).find('.main_productN').find('.itg_add_btn').removeClass('disabled_input');
}
$(document).on('change','#yearFilterSelect_main_product',function(){
  $(document).find('.main_Mak_Filter_product').addClass('loading');
  setTimeout(function() {
  $(document).find('.main_Mak_Filter_product').removeClass('loading');
  },1000);

  var vehicalVal = $(this).val();
  var inputHidden = $('#year_hidden_main_product[type="hidden"]').val(vehicalVal);
  if(inputHidden){
    $(document).find('.main_Mak_Filter_product ').removeClass('disabled');
  }else{
    $(document).find('.main_Mak_Filter_product ').addClass('disabled');
  }
  var check_ymm = vehicalVal+'_';
  var makfilterArry = [];
  $('#makFilterSelect_main_product option[data-value]').remove();
  $('.main_filter-check option').each(function(){
    var filterVal = $(this).val();
  
    var result = filterVal.includes(check_ymm);
    if(result){
      var getfilter = $(this).text().trim();
      var splitfilter = getfilter.split('_');
      var filterOne = splitfilter[2];
      makfilterArry.push(filterOne);
    }
  });
  var uniqueValue = makfilterArry.filter(function(itm, i, makfilterArry) {
    return i == makfilterArry.indexOf(itm);
  });
   $.each(uniqueValue,function(index, value){
      var dataval = value.toLowerCase();
      var dataText = value.toUpperCase();
      var datavalue = dataval.replace(" ","-");
      $("#makFilterSelect_main_product").append('<option class="optionList" data-value="' + datavalue + '" value="' + value + '">' + dataText + '</option>');
      var $select = $("#makFilterSelect_main_product");
      $select.append($select.find(".optionList").remove()
        .sort(function(a, b) {
        var at = $(a).text(),
        bt = $(b).text();
        return (at > bt) ? 1 : ((at < bt) ? -1 : 0);
      }));
   });
  $('#make_hidden_main_product[type="hidden"]').val('');
  $('#makFilterSelect_main_product option[data-attr="disabled-val"]').prop('selected', true);
  $('#model_hidden_main_product[type="hidden"]').val('');
  $('.Model_Filter_main_product ').addClass('disabled');
  $('#modelFilterSelect_main_product option[data-attr="disabled-val"]').prop('selected', true);
  $('#vehicle_hidden_main_product[type="hidden"]').val('');
  $('.vehicle_Filter_main_product').addClass('disabled');
  $('#vehicleFilterSelect_main_product option[data-attr="disabled-val"]').prop('selected', true);
  
  
  var main_yearVal = $(document).find('.form-validation').find('#yearFilterSelect_main_product [data-value]:selected').length;
  var main_makeVal = $(document).find('.form-validation').find('#makFilterSelect_main_product [data-value]:selected').length;
  var main_modelVal = $(document).find('.form-validation').find('#modelFilterSelect_main_product [data-value]:selected').length;
  var main_vehicleVal = $(document).find('.form-validation').find('#vehicleFilterSelect_main_product [data-value]:selected').length;
      
  if(main_yearVal == 0 || main_makeVal == 0 || main_modelVal == 0 || main_vehicleVal == 0 ){
    $(document).find('.main_productN').find('.itg_add_btn').addClass('disabled_input');
  }else{
    $(document).find('.main_productN').find('.itg_add_btn').removeClass('disabled_input');
  }
});

$(document).on('change','#makFilterSelect_main_product',function(){
  $(document).find('.main_Model_Filter_product').addClass('loading');
  setTimeout(function() {
  $(document).find('.main_Model_Filter_product').removeClass('loading');
  },1200);
  var vehicalVal = $(this).val();
  var inputHidden = $('#make_hidden_main_product[type="hidden"]').val(vehicalVal);
 
  if(inputHidden){
    $(document).find('.main_Model_Filter_product ').removeClass('disabled');
  }else{
    $(document).find('.main_Model_Filter_product ').addClass('disabled');
  }

  var year_check = $('#year_hidden_main_product[type="hidden"]').val();
  var check_ymm = year_check+'_'+vehicalVal+'_';
  var makfilterArry = [];
  $('#modelFilterSelect_main_product option[data-value]').remove();
  $('.main_filter-check option').each(function(){
    var filterVal = $(this).val();
    var result = filterVal.includes(check_ymm);
    if(result){
      var getfilter = $(this).text().trim();
      var splitfilter = getfilter.split('_');
      var filterOne = splitfilter[3];
      makfilterArry.push(filterOne);
    }
  });
  var uniqueValue = makfilterArry.filter(function(itm, i, makfilterArry) {
    return i == makfilterArry.indexOf(itm);
  });
   $.each(uniqueValue,function(index, value){
      var dataval = value.toLowerCase();
      var dataText = value.toUpperCase();
      var datavalue = dataval.replace(" ","-");
      $("#modelFilterSelect_main_product").append('<option class="optionList" data-value="' + datavalue + '" value="' + value + '">' + dataText + '</option>');
      var $select = $("#modelFilterSelect_main_product");
      $select.append($select.find(".optionList").remove()
        .sort(function(a, b) {
        var at = $(a).text(),
        bt = $(b).text();
        return (at > bt) ? 1 : ((at < bt) ? -1 : 0);
      }));
   });
    $('#model_hidden_main_product[type="hidden"]').val('');
    $('#modelFilterSelect_main_product option[data-attr="disabled-val"]').prop('selected', true);
    $('#vehicle_hidden_main_product[type="hidden"]').val('');
    $('.vehicle_Filter_main_product').addClass('disabled');
    $('#vehicleFilterSelect_main_product option[data-attr="disabled-val"]').prop('selected', true);
  
  var main_yearVal = $(document).find('.form-validation').find('#yearFilterSelect_main_product [data-value]:selected').length;
  var main_makeVal = $(document).find('.form-validation').find('#makFilterSelect_main_product [data-value]:selected').length;
  var main_modelVal = $(document).find('.form-validation').find('#modelFilterSelect_main_product [data-value]:selected').length;
  var main_vehicleVal = $(document).find('.form-validation').find('#vehicleFilterSelect_main_product [data-value]:selected').length;
      
  if(main_yearVal == 0 || main_makeVal == 0 || main_modelVal == 0 || main_vehicleVal == 0 ){
    $(document).find('.main_productN').find('.itg_add_btn').addClass('disabled_input');
  }else{
    $(document).find('.main_productN').find('.itg_add_btn').removeClass('disabled_input');
  }
});

$(document).on('change','#modelFilterSelect_main_product',function(){
  $(document).find('.main_vehicle_Filter_product').addClass('loading');
  setTimeout(function() {
  $(document).find('.main_vehicle_Filter_product').removeClass('loading');
  },1500);
  
  var vehicalVal = $(this).val();
  var markValue = $('#model_hidden_main_product[type="hidden"]').val(vehicalVal);
 
  if(markValue){
    $('.main_vehicle_Filter_product').removeClass('disabled');
  }else{
    $('.main_vehicle_Filter_product').addClass('disabled');
  }

  var year_check = $('#year_hidden_main_product[type="hidden"]').val();
  var make_check = $('#make_hidden_main_product[type="hidden"]').val();
  var check_ymm = year_check+'_'+ make_check +'_'+vehicalVal+'_';
  
  var makfilterArry = [];
  $('#vehicleFilterSelect_main_product option[data-value]').remove();
  $('.main_filter-check option').each(function(){
    var filterVal = $(this).val();
    var result = filterVal.includes(check_ymm);
    if(result){
      var getfilter = $(this).text().trim();
      var splitfilter = getfilter.split('_');
      var filterOne = splitfilter[4];
      makfilterArry.push(filterOne);
    }
  });
  var uniqueValue = makfilterArry.filter(function(itm, i, makfilterArry) {
    return i == makfilterArry.indexOf(itm);
  });
   $.each(uniqueValue,function(index, value){
      var dataval = value.toLowerCase();
      var dataText = value.toUpperCase();
      var datavalue = dataval.replace(" ","-");
      $("#vehicleFilterSelect_main_product").append('<option class="optionList" data-value="' + datavalue + '" value="' + value + '">' + dataText + '</option>');
      var $select = $("#vehicleFilterSelect_main_product");
      $select.append($select.find(".optionList").remove()
        .sort(function(a, b) {
        var at = $(a).text(),
        bt = $(b).text();
        return (at > bt) ? 1 : ((at < bt) ? -1 : 0);
      }));
   });

  $('#vehicle_hidden_main_product[type="hidden"]').val('');
  $('#vehicleFilterSelect_main_product option[data-attr="disabled-val"]').prop('selected', true);
  
  var main_yearVal = $(document).find('.form-validation').find('#yearFilterSelect_main_product [data-value]:selected').length;
  var main_makeVal = $(document).find('.form-validation').find('#makFilterSelect_main_product [data-value]:selected').length;
  var main_modelVal = $(document).find('.form-validation').find('#modelFilterSelect_main_product [data-value]:selected').length;
  var main_vehicleVal = $(document).find('.form-validation').find('#vehicleFilterSelect_main_product [data-value]:selected').length;
      
  if(main_yearVal == 0 || main_makeVal == 0 || main_modelVal == 0 || main_vehicleVal == 0 ){
    $(document).find('.main_productN').find('.itg_add_btn').addClass('disabled_input');
  }else{
    $(document).find('.main_productN').find('.itg_add_btn').removeClass('disabled_input');
  }
});

$(document).on('change','#vehicleFilterSelect_main_product',function(){
  var vehicalVal = $(this).val();
  var inputHidden = $('#vehicle_hidden_main_product[type="hidden"]').val(vehicalVal);
  
  var main_yearVal = $(document).find('.form-validation').find('#yearFilterSelect_main_product [data-value]:selected').length;
  var main_makeVal = $(document).find('.form-validation').find('#makFilterSelect_main_product [data-value]:selected').length;
  var main_modelVal = $(document).find('.form-validation').find('#modelFilterSelect_main_product [data-value]:selected').length;
  var main_vehicleVal = $(document).find('.form-validation').find('#vehicleFilterSelect_main_product [data-value]:selected').length;
      
  if(main_yearVal == 0 || main_makeVal == 0 || main_modelVal == 0 || main_vehicleVal == 0 ){
    $(document).find('.main_productN').find('.itg_add_btn').addClass('disabled_input');
  }else{
    $(document).find('.main_productN').find('.itg_add_btn').removeClass('disabled_input');
  }


    var year = $('#yearFilterSelect_main_product').find(":selected").val();
    var make = $('#makFilterSelect_main_product').find(":selected").val();
    var modal = $('#modelFilterSelect_main_product').find(":selected").val();
    var findcombine = '/search?type=product&q=Filter_'+year+'_'+make+'_'+modal+'_'+vehicalVal;
  console.log(findcombine);
    $.ajax({
        url: `${findcombine}`,
        method: "GET",
        dataType: "html",
      }).done(function (responseText) {
        const responseHTML = new DOMParser().parseFromString(responseText,"text/html");
        var searchElement = $(responseHTML).find(".search_page").html();
        $(searchElement).find('.search-result').each(function(){
          var searchProductHandle = $(this).find('.search-text').data('handle');
          var productTileTemplate = '/products/' + searchProductHandle;
          console.log(productTileTemplate);
            $.ajax({
              url:productTileTemplate,
              method: "GET",
              dataType: "json",
               }).done(function (responseProduct) {
                $.each(responseProduct, function(key, value) {  
                  var prodImg = value.image.src;
                   if(prodImg == null ){
                     var productImage = '';
                   }else{
                     var productImage = value.image.src;
                   }
                   var productTitle = value.title;
                   var firstvariantId = value.variants[0].id;
                   var firstvariantPrice = value.variants[0].price;
                   var firstComparePrice = value.variants[0].compare_at_price;
                   var option_val = value.variants;  
                   var splitTag = value.tags.split(', ');
                   var CollectionBase = '' ;
                   var TagAvi = 'NotTag';
                   var handleTag = $('.main_ymm_flyout').data('product');
                   var  handleTitle = $('.main_ymm_flyout').data('p');
                   var PAvi = 'NotP';
                    if(handleTitle == productTitle ){
                         PAvi = 'yesP';
                    }
                    $.each(splitTag, function (index,value) {
                      var strc =  $('.main_ymm_flyout').data('collection');
                      if (value.indexOf(strc) > -1) {
                        var aviCollection =  value.split('_');
                        if(handleTag == aviCollection[1] ){
                           CollectionBase = aviCollection[1] ;
                           TagAvi = 'TagAvi';
                        }
                      }
                      
                    });
                    if(option_val.length > 1){
                      var selected = $('.form-validation').find('.no-js').find('select option:selected').data('title');
                      console.log(selected);
                      var variantId = $('.form-validation').find('.no-js').find('select option:selected').val();
                      var selectOption = '<div class="main_product-option"><p>'+ selected +'</p></div>';
                       $(".main_ymmc_product").append('<label class="main_variant_option" data-product="'+PAvi+'" data-handle="'+ TagAvi +'"><span> ' + productTitle +  '</span>' +selectOption + '</label>');
                    }else{
                      $(".main_ymmc_product").append('<label class="main_product_option"  data-product="'+PAvi+'" data-handle="'+ TagAvi +'"> <span> ' + productTitle +  '</span>'  + '</label>');
                    }
                  
                });
              
              }).fail(function (jqXHR, textStatus, errorThrown) {
                 console.log('errordata'); 
            });
        });
      }).fail(function (jqXHR, textStatus, errorThrown) {
		 console.log('errordata'); 
	  });
  
});

$(document).on('click','.main_productN .add-to-cart',function(){
    var yearProp = $('#year_hidden_main_product[type="hidden"]').val();
    var makeProp = $('#make_hidden_main_product[type="hidden"]').val();
    var modalProp = $('#model_hidden_main_product[type="hidden"]').val();
    var confrigProp = $('#vehicle_hidden_main_product[type="hidden"]').val();
    var ymmProp = yearProp +' '+ makeProp +' '+ modalProp +' '+ confrigProp ;
    $('#For_Vehicle').val(ymmProp);
  
   var checked = $(this).hasClass('disabled_input');
    if(checked){
      event.preventDefault();
       var validation = 0;
    }else{
      var validation = 1;
    }
    var main_yearVal = $(document).find('.form-validation').find('#yearFilterSelect_main_product [data-value]:selected').length;
    var main_makeVal = $(document).find('.form-validation').find('#makFilterSelect_main_product [data-value]:selected').length;
    var main_modelVal = $(document).find('.form-validation').find('#modelFilterSelect_main_product [data-value]:selected').length;
    var main_vehicleVal = $(document).find('.form-validation').find('#vehicleFilterSelect_main_product [data-value]:selected').length;
    if(main_yearVal == 1 && main_makeVal == 1 && main_modelVal == 1 && main_vehicleVal == 1 ){
      $('#year_hidden_main_product[type="hidden"]').val('');
      $('#yearFilterSelect_main_product option[data-attr="disabled-val"]').prop('selected', true);
      $('#make_hidden_main_product[type="hidden"]').val('');
      $('#makFilterSelect_main_product option[data-attr="disabled-val"]').prop('selected', true);
      $('.main_Mak_Filter_product ').addClass('disabled');
      $('#model_hidden_main_product[type="hidden"]').val('');
      $('.Model_Filter_main_product ').addClass('disabled');
      $('#modelFilterSelect_main_product option[data-attr="disabled-val"]').prop('selected', true);
      $('#vehicle_hidden_main_product[type="hidden"]').val('');
      $('.vehicle_Filter_main_product').addClass('disabled');
      $('#vehicleFilterSelect_main_product option[data-attr="disabled-val"]').prop('selected', true);
    }
});

// Category Product


  //   localStorage.removeItem('cateymm');
  //   $(document).find('.Year_Filter_product').addClass('loading');
  //   $(document).find('.Year_Filter_product').addClass('disabled');
  //   var current_data_collection_cate = "";
  //   var page_info_cate = "";
  //   function allproduct_loop_cate() {
  //       if (page_info_cate == "") {
  //           current_data_collection_cate = "https://www.autotech-park.com/search?view=productFilter";
  //       } else {
  //           current_data_collection_cate = page_info_cate;
  //       }
  //       $.ajax({
  //           method: "GET",
  //           url: current_data_collection_cate,
  //           dataType: "HTML",
  //           beforeSend: function () {},
  //           data: {},
  //       }).done(function (data) {
  //           var allhtml_cate = $(data).find(".allTag_product_ymm").html();
  //           if (allhtml_cate != '') {
  //               $(document).find('.product_hidden-main select').append(allhtml_cate);

  //               var pagination_cate = $(data).find(".pagiantion_bottom-ymm").text();
  //               page_info_cate = pagination_cate;
  //               if (pagination_cate != "") {
  //                   allproduct_loop_cate(); // Continue pagination
  //               } else {
  //                   // Pagination complete, hide loading indicator
  //                 setTimeout(()=>{
  //                   processOptionscate();
  //                 },1000);
  //               }
  //               var collhandle = $('.product_c').data('tag');
  //               var storage_cate = $(document).find('.product_hidden-main select option[data-tags="'+collhandle+'"]');
  //               $(document).find('.checkFilter_product').append(storage_cate);
  //               var storage_productCate = $(document).find('.hidden_ymm').html();
  //               localStorage.setItem('cateymm', storage_productCate);
  //           }
  //       });
  //   }

  //   var search_yeardata_cate = localStorage.getItem('cateymm');
  // // console.log(search_yeardata_cate);
  //   if (search_yeardata_cate == null) {
  //       allproduct_loop_cate();
  //   } else {
  //       $(document).find('.hidden_ymm').html('');
  //       $(document).find('.hidden_ymm').html(search_yeardata_cate);
  //       setTimeout(()=>{
  //         processOptionscate();
  //       },1000);
  //   }
  //      function processOptionscate() {
  //       var getDataSearch = localStorage.getItem('cateymm');
  //       if (getDataSearch) {
  //           var yearFilterA = [];
  //           var makeFilterA = [];
  //           var modalFilterA = [];
  //           var confiFilterA = [];
  //           $(getDataSearch).find('option[data-value]').each(function () {
  //               var filterloop = $(this).val();
  //             // console.log(filterloop);
  //               var filterSplit = filterloop.split('_');
  //               var filterSplitOne = filterSplit[1];
  //               yearFilterA.push(filterSplitOne);
  //               var filterSplitTwo = filterSplit[2];
  //               makeFilterA.push(filterSplitTwo);
  //               var filterSplitThree = filterSplit[3];
  //               modalFilterA.push(filterSplitThree);
  //               var filterSplitfour = filterSplit[4];
  //               confiFilterA.push(filterSplitfour);
  //           });

  //           var uniqueValue = yearFilterA.filter(function(itm, i, yearFilterA) {
  //             return i == yearFilterA.indexOf(itm);
  //           });
  //            $.each(uniqueValue,function(index, value){
  //             var dataval = value.toLowerCase();
  //             var dataText = value.toUpperCase();
  //             var datavalue = dataval.replace(" ","-");
  //             $("#yearFilterSelect_product").append('<option class="optionList" data-value="' + datavalue + '" value="' + value + '">' + dataText + '</option>');
  //             var $select = $("#yearFilterSelect_product");
  //             $select.append($select.find(".optionList").remove()
  //               .sort(function(a, b) {
  //               var at = $(a).text(),
  //               bt = $(b).text();
  //               return (at < bt) ? 1 : ((at > bt) ? -1 : 0);
  //             }));
  //            });
        
  //           // Similar processing for other filters...
  //         $(document).find('.Year_Filter_product ').removeClass('loading');
  //         $(document).find('.Year_Filter_product ').removeClass('disabled');
  //       }
  //   }
   
if($('.product-template').find('.category_product').length == 1){
    var yearVal = $(document).find('.category_product').find('#yearFilterSelect_product [data-value]:selected').length;
    var makeVal = $(document).find('.category_product').find('#makFilterSelect_product [data-value]:selected').length;
    var modelVal = $(document).find('.category_product').find('#modelFilterSelect_product [data-value]:selected').length;
    var vehicleVal = $(document).find('.category_product').find('#vehicleFilterSelect_product [data-value]:selected').length;
    
    if(yearVal == 0 || makeVal == 0 || modelVal == 0 || vehicleVal == 0 ){
      $(document).find('.category_product').find('.cate_btn').addClass('disabled_input');
    }else{
      $(document).find('.category_product').find('.cate_btn').removeClass('disabled_input');
    }
 }

$(document).on('change','#yearFilterSelect_product',function(){
  $(document).find('.ymmc_product').empty();
  $(document).find('.custom_err').remove();
  $('#product-container').empty();
  $(document).find('.cate_btn').attr('data-id','');

  $(document).find('.Mak_Filter_product').addClass('loading');
  setTimeout(function() {
    $(document).find('.Mak_Filter_product').removeClass('loading');
  },1000);
  var vehicalVal = $(this).val();
  var inputHidden = $('#year_hidden_product[type="hidden"]').val(vehicalVal);
  
  if(inputHidden){
    $(document).find('.Mak_Filter_product ').removeClass('disabled');
  }else{
    $(document).find('.Mak_Filter_product ').addClass('disabled');
  }
    var check_ymm = vehicalVal+'_';
    var makfilterArry = [];
    $('#makFilterSelect_product option[data-value]').remove();
    $('.checkFilter_product option').each(function(){
      var filterVal = $(this).val();
      var result = filterVal.toLowerCase().includes(check_ymm.toLowerCase());
      // var result = filterVal.includes(check_ymm);
      if(result){
        var getfilter = $(this).text().trim();
        var splitfilter = getfilter.split('_');
        var filterOne = splitfilter[2];
        makfilterArry.push(filterOne);
      }
    });
    var uniqueValue = makfilterArry.filter(function(itm, i, makfilterArry) {
       return i == makfilterArry.findIndex(t => t.toLowerCase() === itm.toLowerCase());
    });
     $.each(uniqueValue,function(index, value){
        var dataval = value.toLowerCase().replace(/\s+/g, "-");
        var dataText = value.toUpperCase();
        var datavalue = dataval.replace(" ","-");
        $("#makFilterSelect_product").append('<option class="optionList" data-value="' + datavalue + '" value="' + value + '">' + dataText + '</option>');
        var $select = $("#makFilterSelect_product");
        $select.append($select.find(".optionList").remove()
          .sort(function(a, b) {
          var at = $(a).text(),
          bt = $(b).text();
          return (at > bt) ? 1 : ((at < bt) ? -1 : 0);
        }));
     });
    $('#make_hidden_product[type="hidden"]').val('');
    $('#makFilterSelect_product option[data-attr="disabled-val"]').prop('selected', true);
    $('#model_hidden_product[type="hidden"]').val('');
    $('.Model_Filter_product ').addClass('disabled');
    $('#modelFilterSelect_product option[data-attr="disabled-val"]').prop('selected', true);
    $('#vehicle_hidden_product[type="hidden"]').val('');
    $('.vehicle_Filter_product').addClass('disabled');
    $('#vehicleFilterSelect_product option[data-attr="disabled-val"]').prop('selected', true);
  
    var yearVal = $(document).find('.category_product').find('#yearFilterSelect_product [data-value]:selected').length;
    var makeVal = $(document).find('.category_product').find('#makFilterSelect_product [data-value]:selected').length;
    var modelVal = $(document).find('.category_product').find('#modelFilterSelect_product [data-value]:selected').length;
    var vehicleVal = $(document).find('.category_product').find('#vehicleFilterSelect_product [data-value]:selected').length;
    
    if(yearVal == 0 || makeVal == 0 || modelVal == 0 || vehicleVal == 0 ){
      $(document).find('.category_product').find('.cate_btn').addClass('disabled_input');
    }else{
      $(document).find('.category_product').find('.cate_btn').removeClass('disabled_input');
    }
   
});

$(document).on('change','#makFilterSelect_product',function(){
  $(document).find('.ymmc_product').empty();
  $(document).find('.custom_err').remove();
  $(document).find('.cate_btn').attr('data-id','');
  $(document).find('.Model_Filter_product').addClass('loading');
  setTimeout(function() {
    $(document).find('.Model_Filter_product').removeClass('loading');
  },1200);
  var vehicalVal = $(this).val();
  var inputHidden = $('#make_hidden_product[type="hidden"]').val(vehicalVal);
 
  if(inputHidden){
    $(document).find('.Model_Filter_product ').removeClass('disabled');
  }else{
    $(document).find('.Model_Filter_product ').addClass('disabled');
  }

  var year_check = $('#year_hidden_product[type="hidden"]').val();
  var check_ymm = year_check+'_'+vehicalVal+'_';
  var makfilterArry = [];
  $('#modelFilterSelect_product option[data-value]').remove();
  $('.checkFilter_product option').each(function(){
    var filterVal = $(this).val();
    // var result = filterVal.includes(check_ymm);
     var result = filterVal.toLowerCase().includes(check_ymm.toLowerCase());
    if(result){
      var getfilter = $(this).text().trim();
      var splitfilter = getfilter.split('_');
      var filterOne = splitfilter[3];
      makfilterArry.push(filterOne);
    }
  });
  var uniqueValue = makfilterArry.filter(function(itm, i, makfilterArry) {
     return i == makfilterArry.findIndex(t => t.toLowerCase() === itm.toLowerCase());
  });
   $.each(uniqueValue,function(index, value){
      var dataval = value.toLowerCase().replace(/\s+/g, "-");
      var dataText = value.toUpperCase();
      var datavalue = dataval.replace(" ","-");
      $("#modelFilterSelect_product").append('<option class="optionList" data-value="' + datavalue + '" value="' + value + '">' + dataText + '</option>');
      var $select = $("#modelFilterSelect_product");
      $select.append($select.find(".optionList").remove()
        .sort(function(a, b) {
        var at = $(a).text(),
        bt = $(b).text();
        return (at > bt) ? 1 : ((at < bt) ? -1 : 0);
      }));
   });
    $('#model_hidden_product[type="hidden"]').val('');
    $('#modelFilterSelect_product option[data-attr="disabled-val"]').prop('selected', true);
    $('#vehicle_hidden_product[type="hidden"]').val('');
    $('.vehicle_Filter_product').addClass('disabled');
    $('#vehicleFilterSelect_product option[data-attr="disabled-val"]').prop('selected', true);
  
    var yearVal = $(document).find('.category_product').find('#yearFilterSelect_product [data-value]:selected').length;
    var makeVal = $(document).find('.category_product').find('#makFilterSelect_product [data-value]:selected').length;
    var modelVal = $(document).find('.category_product').find('#modelFilterSelect_product [data-value]:selected').length;
    var vehicleVal = $(document).find('.category_product').find('#vehicleFilterSelect_product [data-value]:selected').length;
    
    if(yearVal == 0 || makeVal == 0 || modelVal == 0 || vehicleVal == 0 ){
      $(document).find('.category_product').find('.cate_btn').addClass('disabled_input');
    }else{
      $(document).find('.category_product').find('.cate_btn').removeClass('disabled_input');
    }
});

$(document).on('change','#modelFilterSelect_product',function(){
  $(document).find('.ymmc_product').empty();
  $(document).find('.custom_err').remove();
  $(document).find('.cate_btn').attr('data-id','');
  $(document).find('.vehicle_Filter_product').addClass('loading');
  setTimeout(function() {
    $(document).find('.vehicle_Filter_product').removeClass('loading');
  },1500);
  
  var vehicalVal = $(this).val();
  var markValue = $('#model_hidden_product[type="hidden"]').val(vehicalVal);
 
  if(markValue){
    $('.vehicle_Filter_product').removeClass('disabled');
  }else{
    $('.vehicle_Filter_product').addClass('disabled');
  }

  var year_check = $('#year_hidden_product[type="hidden"]').val();
  var make_check = $('#make_hidden_product[type="hidden"]').val();
  var check_ymm = year_check+'_'+ make_check +'_'+vehicalVal+'_';
  
  var makfilterArry = [];
  $('#vehicleFilterSelect_product option[data-value]').remove();
  $('.checkFilter_product option').each(function(){
    var filterVal = $(this).val();
     var result = filterVal.toLowerCase().includes(check_ymm.toLowerCase());
    // var result = filterVal.includes(check_ymm);
    if(result){
      var getfilter = $(this).text().trim();
      var splitfilter = getfilter.split('_');
      var filterOne = splitfilter[4];
      makfilterArry.push(filterOne);
    }
  });
  var uniqueValue = makfilterArry.filter(function(itm, i, makfilterArry) {
    return i == makfilterArry.findIndex(t => t.toLowerCase() === itm.toLowerCase());
  });
   $.each(uniqueValue,function(index, value){
      var dataval = value.toLowerCase().replace(/\s+/g, "-");
      var dataText = value.toUpperCase();
      var datavalue = dataval.replace(" ","-");
      $("#vehicleFilterSelect_product").append('<option class="optionList" data-value="' + datavalue + '" value="' + value + '">' + dataText + '</option>');
      var $select = $("#vehicleFilterSelect_product");
      $select.append($select.find(".optionList").remove()
        .sort(function(a, b) {
        var at = $(a).text(),
        bt = $(b).text();
        return (at > bt) ? 1 : ((at < bt) ? -1 : 0);
      }));
   });

  $('#vehicle_hidden_product[type="hidden"]').val('');
  $('#vehicleFilterSelect_product option[data-attr="disabled-val"]').prop('selected', true);
  
  var yearVal = $(document).find('.category_product').find('#yearFilterSelect_product [data-value]:selected').length;
  var makeVal = $(document).find('.category_product').find('#makFilterSelect_product [data-value]:selected').length;
  var modelVal = $(document).find('.category_product').find('#modelFilterSelect_product [data-value]:selected').length;
  var vehicleVal = $(document).find('.category_product').find('#vehicleFilterSelect_product [data-value]:selected').length;
  
  if(yearVal == 0 || makeVal == 0 || modelVal == 0 || vehicleVal == 0 ){
    $(document).find('.category_product').find('.cate_btn').addClass('disabled_input');
  }else{
    $(document).find('.category_product').find('.cate_btn').removeClass('disabled_input');
  }
});

$(document).on('change','#vehicleFilterSelect_product',function(){
  $(document).find('.ymmc_product').empty();
  $(document).find('.custom_err').remove();
  $(document).find('.cate_btn').addClass('loading');
  $(document).find('.cate_btn').attr('data-id','');
  var vehicalVal = $(this).val();
  var inputHidden = $('#vehicle_hidden_product[type="hidden"]').val(vehicalVal);
  
 
    var year = $('#yearFilterSelect_product').find(":selected").val();
    var make = $('#makFilterSelect_product').find(":selected").val();
    var modal = $('#modelFilterSelect_product').find(":selected").val();
    var findcombine = '/search?type=product&q=Filter_'+year+'_'+make+'_'+modal+'_'+vehicalVal;
  console.log(findcombine);
    $.ajax({
        url: `${findcombine}`,
        method: "GET",
        dataType: "html",
      }).done(function (responseText) {
        const responseHTML = new DOMParser().parseFromString(responseText,"text/html");
        var searchElement = $(responseHTML).find(".search-page").html();
      console.log(searchElement);
        var handleTag = $('.ymm_flyout').data('product');
      console.log(handleTag);
        $(searchElement).find('.search-result').each(function(){
           var searchCollection = $(this).find('.search-text').data('collection');
          console.log(searchCollection);
          if(handleTag == searchCollection ){
            var searchProductHandle = $(this).find('.search-text').data('handle');
          // var soldOutVariant = $(this).find('.search-text').find('.soldout_product ').data('id');
          
          var productTileTemplate = '/products/' + searchProductHandle;
            $.ajax({
              url:productTileTemplate,
              method: "GET",
              dataType: "html",
               }).done(function (responseProduct) {
               var htmlFind = $(responseProduct).find('.main_product-hide').html();
                $(".ymmc_product").append(htmlFind);
                 var labelLength = $('.ymmc_product').find('label').length; 
                  $('.ymmc_product').find('input:first').prop('checked',true);
                  if( labelLength > 1){
                    $('.ymmc_product').find('label').removeClass('input_hide');
                  }else{
                    $('.ymmc_product').find('label').addClass('input_hide');
                  }
                   var checked =  $('.product_content input:checked').data('id');

                  $('.product_content').each(function(){
                    var result = $(this).find('input.sold_out').data('id');
                    // console.log(result);
                    if(result == checked ){ 
                      $(document).find('.category_product').find('.cate_btn').addClass('outline');
                      $(document).find('.category_product').find('.cate_btn').text('sold out');
                      $(document).find('.category_product').find('.cate_btn').addClass('disabled_input');
                    }else{
                      $(document).find('.category_product').find('.cate_btn').removeClass('disabled_input');
                      $(document).find('.category_product').find('.cate_btn').removeClass('outline');
                      $(document).find('.category_product').find('.cate_btn').text('Add to cart');
                    }
                  });

              
                  $(document).find('.category_product').find('.cate_btn').attr('data-id',checked);
                  $(document).find('.cate_btn').removeClass('loading');
                  
            });
      
           }
        });
         
      }).fail(function (jqXHR, textStatus, errorThrown) {
		 console.log('errordata'); 
	  });
  
});
$(document).on('change','.ymmc_product input', function(){
  var variantId = $(this).data('id');
  $(document).find('.category_product').find('.cate_btn').attr('data-id',variantId);
});
 $(document).on('change','.product_content select', function(){
  var valSelected  = $(this).find('option:selected').val();
  // console.log(valSelected);
  $(document).find('.category_product').find('.cate_btn').attr('data-id',valSelected);
});
$(document).on('click','.category_product .cate_btn',function(){
  event.preventDefault();
    var variantId = $(this).data('id');
    var qty =  $('.custom-qtn-btn-wrapper').find('input[name="quantity"]').val();
  var qtyCh =  $('.product_content input:checked').data('qty');
    var yearProp = $('#year_hidden_product[type="hidden"]').val();
    var makeProp = $('#make_hidden_product[type="hidden"]').val();
    var modalProp = $('#model_hidden_product[type="hidden"]').val();
    var confrigProp = $('#vehicle_hidden_product[type="hidden"]').val();
    var ymmProp = yearProp +' '+ makeProp +' '+ modalProp +' '+ confrigProp ;
    if(qtyCh <= qty ){
      if($('.custom-qtn-btn-main').find('.error').length == 0){
        $('.custom-qtn-btn-main input[name="quantity"]').after('<label class="error custom_err">Value must be lower</label>');
      }
    }else{
      
    data = {
      "id": variantId,
      "quantity": qty,
      "properties": {
        "For Vehicle": ymmProp,
      }
    }
    
    if(variantId){
      $.ajax({
      type: 'POST',
      url: '/cart/add.js',
      data: data,
      dataType: 'json', 
      success: function(returnedHtml){
          $('#year_hidden_main_product[type="hidden"]').val('');
          $('#yearFilterSelect_main_product option[data-attr="disabled-val"]').prop('selected', true);
          $('#make_hidden_main_product[type="hidden"]').val('');
          $('#makFilterSelect_main_product option[data-attr="disabled-val"]').prop('selected', true);
          $('.main_Mak_Filter_product ').addClass('disabled');
          $('#model_hidden_main_product[type="hidden"]').val('');
          $('.Model_Filter_main_product ').addClass('disabled');
          $('#modelFilterSelect_main_product option[data-attr="disabled-val"]').prop('selected', true);
          $('#vehicle_hidden_main_product[type="hidden"]').val('');
          $('.vehicle_Filter_main_product').addClass('disabled');
          $('#vehicleFilterSelect_main_product option[data-attr="disabled-val"]').prop('selected', true);
  
        window.location.href = '/cart';
        }
      });
   }
    }
      
});

});
// console.log();
if($('body').find('.mainfilter_product').length == 1){
  window.addEventListener("pageshow", function ( event ) {
  var historyTraversal = event.persisted || ( typeof window.performance != "undefined" && window.performance.navigation.type === 2 );
  if(historyTraversal ) {
    location.reload();
    // page reload
  }
  });
}
